module.exports = __webpack_public_path__ + "img/patern-01.4ed0a1e7.png";